import { rootApi } from "../../api/rootApi";

export const pendingQrsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchPendingQrs: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: "/tenant/pending-qrs/pending-qr-list",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        approvePendingRequest: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: "/tenant/pending-qrs/approve-pending-qr",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        rejectPendingRequest: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: "/tenant/pending-qrs/reject-pending-qr",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
    }),
});

export const {
    useFetchPendingQrsMutation,
    useApprovePendingRequestMutation,
    useRejectPendingRequestMutation,
} = pendingQrsApi;
